'use strict';

var base = require('base/product/base');

/**
 * sets the selection warning before add to car
 * @param {jQuery} $el jQuer element
 * @returns {boolean} has selected value
 */
function setSelectionWarning($el) {
    const $select = $el.find('.attr-size-select select');
    const hasSelectedValue = !!($el.find('a.selected, div[data-attr].selected').length > 0 ||
        !!($select && $select.length > 0 &&
            $select.val() &&
            $select.val().length > 0 &&
            $select.val() !== 'null'));
    $el.toggleClass('no-attr-value', !hasSelectedValue);
    return hasSelectedValue;
}


module.exports = {
    zakUpdateButton: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            const $productContainer = $(response.$productContainer);
            const $zakDiv = $productContainer.find('#zakDiv');
            
            if (!($zakDiv && $zakDiv.length)) {
                return;
            }

            const $tilePlpRedirect = $(e.target).parents('[data-tile-pdp-redirect]');
            const product = response.product;
            const ready = (product.readyToOrder && product.available);
            let show = false;

            if ($tilePlpRedirect.length && $tilePlpRedirect.attr('data-tile-pdp-redirect') !== 'false') {
                $tilePlpRedirect.attr('data-tile-pdp-redirect', product.productSetProductUrl);
            }

            if (ready === true) {
                if (product.ZAKEKE_is_customizable) {
                    show = true;
                }
            }

            if (show) {
                const $zakButton = $zakDiv.find('#zak-button');
                const $zakUrl = $('#zakUrl');
                var url = $zakUrl.val() + '?pid=' + encodeURIComponent(product.id);
                $zakButton.prop('data-zak-pid', product.id);
                $zakButton.spinner().start();

                // it isn't called if #zakDiv is undefined (if Zakeke not enabled)
                $zakDiv.load(url, () => {
                    $zakDiv.css('display', 'block');
                    $.spinner().stop();
                });
            } else {
                $zakDiv.css('display', 'none');
            }
        });


        $('body').on('click', '#zak-button', function (e) {
            const $tilePlpRedirect = $(e.target).parents('[data-tile-pdp-redirect]');
            if ($tilePlpRedirect.length && $tilePlpRedirect.attr('data-tile-pdp-redirect').length > 0) {
                window.location.href = $tilePlpRedirect.attr('data-tile-pdp-redirect');
                return;
            }
            const $productContainerPid = $(this).parents('[data-pid]');
            if ($productContainerPid.length) {
                const selectionWarnings = $productContainerPid
                    .find('[data-attr-id]:visible')
                    .map((index, el) => setSelectionWarning($(el)));
                const hasNonSelectedValue = selectionWarnings
                    .toArray()
                    .some(val => !val);
                $.spinner().stop();
                if (!hasNonSelectedValue) {
                    const url = $('#zak-button').attr('url-data');
                    $('#zak-modal .modal-body').load(url, () => {
                        $('#zak-modal').modal('show');
                        $(document).trigger('Zakeke:ModalLoaded');
                    });
                }
            }
        });

        $(document).on('hide.bs.modal', '#zak-modal', () => {
            $('#zak-modal .modal-body').empty();
        });

        $(document).on('hidden.bs.modal', '#zak-modal', () => {
            $('.product-detail-fixedinfo').show();
        });

        $(document).on('shown.bs.modal', '#zak-modal', () => {
            $('.product-detail-fixedinfo').hide();
        });
    }

};
